import React, { useState } from "react";
import faq_img from "../../assets/pictures/aboutfaq.png";
import "./FAQ.css";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "How quickly can you respond to emergency calls?",
      answer: "We pride ourselves on fast response times. For emergency calls, we typically respond within 30-60 minutes during business hours and up to 2 hours during off-peak times. Our 24/7 emergency hotline ensures you always have someone to call."
    },
    {
      question: "What services are covered in your maintenance packages?",
      answer: "Our comprehensive maintenance packages cover electrical work, plumbing, AC maintenance, painting, carpentry, masonry, water tank cleaning, and general repairs. Each package is customizable based on your property's specific needs."
    },
    {
      question: "Are your technicians licensed and insured?",
      answer: "Yes! All our technicians are fully licensed, insured, and certified professionals. We maintain high standards of training and regularly update our team's skills with the latest industry practices."
    },
    {
      question: "Do you provide warranties on your work?",
      answer: "Absolutely. We stand behind our work with comprehensive warranties. Most repairs come with a 1-year warranty, and we offer extended warranties for major installations. Your satisfaction is guaranteed."
    },
    {
      question: "Can I schedule services at a time convenient for me?",
      answer: "Yes! We offer flexible scheduling to fit your lifestyle. You can book appointments online, via WhatsApp, or by calling us. We also provide weekend and evening services upon request."
    },
    {
      question: "What areas do you serve?",
      answer: "We currently provide our professional home maintenance services exclusively across Dubai, including residential, commercial, and villa properties. Contact us to confirm service availability in your specific area within Dubai."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq_container">
      <div className="faq_header">
        <h2>Frequently Asked <span>Questions</span></h2>
        <p>Find answers to common questions about our services</p>
      </div>

      <div className="faq_content">
        <div className="faq_list">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq_item ${activeIndex === index ? "active" : ""}`}
            >
              <div
                className="faq_question"
                onClick={() => toggleAccordion(index)}
              >
                <div className="faq_question_text">
                  <span className="faq_number">{index + 1}</span>
                  <h4>{item.question}</h4>
                </div>
                <div className="faq_toggle">
                  {activeIndex === index ? "−" : "+"}
                </div>
              </div>
              <div className={`faq_answer ${activeIndex === index ? "show" : ""}`}>
  <p>{item.answer}</p>
</div>
            </div>
          ))}
        </div>

        <div className="faq_testimonials">
  <img
    src={faq_img}
    alt="Customer Support"
    className="faq_side_image"
  />
</div>

      </div>
      <div className="section_line"></div>
    </div>
  );
}

export default FAQ;
